(function () {
    'use strict';

    const AVAILABILITY_ENDPOINT = 'https://php.shopcode.cz/api/klasek/api-availability.php';

    let availabilityTimer = null;
    let availabilityController = null;

    /**
     * Vrátí datum ve formátu YYYY-MM-DD.
     *
     * Uprav selektory podle pole, ve kterém máš datum objednávky.
     */
    function getAvailabilityDate() {
        /*
        * 1. Datum z potvrzeného termínu vyzvednutí.
        */
        const calendarConfig =
            window.klasekCalendar &&
            window.klasekCalendar.config
                ? window.klasekCalendar.config
                : null;

        if (
            calendarConfig &&
            calendarConfig.storagePickupKey
        ) {
            const storedPickup = localStorage.getItem(
                calendarConfig.storagePickupKey
            );

            if (storedPickup) {
                try {
                    const pickup = JSON.parse(storedPickup);

                    if (
                        pickup &&
                        typeof pickup.date === 'string' &&
                        /^\d{4}-\d{2}-\d{2}$/.test(pickup.date)
                    ) {
                        return pickup.date;
                    }
                } catch (error) {
                    console.warn(
                        'Nepodařilo se načíst potvrzený termín:',
                        error
                    );
                }
            }
        }

        /*
        * 2. Datum právě vybrané v kalendáři,
        * i když ještě nebyl potvrzen čas.
        */
        if (
            calendarConfig &&
            calendarConfig.storageDateKey
        ) {
            const storedDate = localStorage.getItem(
                calendarConfig.storageDateKey
            );

            if (
                typeof storedDate === 'string' &&
                /^\d{4}-\d{2}-\d{2}$/.test(storedDate)
            ) {
                return storedDate;
            }
        }

  

        /*
        * 4. Případné datumové pole.
        */
        const dateInput = document.querySelector(
            'input[name="deliveryDate"], ' +
            'input[name="delivery_date"], ' +
            'input[type="date"]'
        );

        if (
            dateInput &&
            /^\d{4}-\d{2}-\d{2}$/.test(dateInput.value)
        ) {
            return dateInput.value;
        }

        /*
        * Bez vybraného data raději nevracíme dnešek.
        * Jinak by košík ukazoval dostupnost pro jiný den.
        */
        return null;
    }

    /**
     * Zjistí a jednorázově uloží PŮVODNÍ (skladovou) max hodnotu,
     * kterou vyrenderoval Shoptet do data-max-available-quantity
     * na <tr> a do max/data-max-available na inputu.
     *
     * Musí se zavolat DŘÍV, než setRowAvailability poprvé přepíše
     * tyto atributy hodnotou z API - jinak se skladový limit ztratí.
     */
    function captureNativeMaxQuantity(row) {
        // Už uloženo (např. při předchozím volání API pro stejné
        // vykreslení košíku) - nepřepisovat.
        if (row.dataset.nativeMaxQuantity !== undefined) {
            return;
        }

        const amountInput = row.querySelector('input.amount');

        const fromRow = parseInt(
            row.getAttribute('data-max-available-quantity'),
            10
        );

        const fromInput = amountInput
            ? parseInt(amountInput.getAttribute('max'), 10)
            : NaN;

        // Pokud sklad Shoptet vůbec neomezuje (žádný max
        // atribut), nastavíme Infinity - pak rozhoduje jen API.
        const nativeMax = Number.isFinite(fromRow)
            ? fromRow
            : (Number.isFinite(fromInput) ? fromInput : Infinity);

        row.dataset.nativeMaxQuantity = String(nativeMax);
    }

    /**
     * Nastaví maximální množství do jednoho řádku košíku.
     *
     * Výsledný limit = MENŠÍ z dvojice:
     *  - skladový/native max, který vyrenderoval Shoptet (sklad),
     *  - availableQuantity vrácené z API (limit na pečicí den).
     *
     * Tím zajistíme, že si nikdo nekoupí víc kusů, než kolik je
     * fyzicky na skladě, i kdyby API pro daný den povolovalo víc.
     */
    function setRowAvailability(row, product) {
        const amountInput = row.querySelector('input.amount');
        const increaseButton = row.querySelector('button.increase');
        const increaseTooltip = row.querySelector(
            '.js-increase-tooltip'
        );

        const availabilityLabels = row.querySelectorAll(
            '.availability-label'
        );

        const apiAvailableQuantity = Math.max(
            0,
            parseInt(product.availableQuantity, 10) || 0
        );

        const nativeMaxRaw = row.dataset.nativeMaxQuantity !== undefined
            ? parseInt(row.dataset.nativeMaxQuantity, 10)
            : NaN;

        const nativeMaxQuantity = Number.isFinite(nativeMaxRaw)
            ? nativeMaxRaw
            : Infinity;

        // Efektivní (skutečně použitelný) max = ten menší.
        const availableQuantity = Math.min(
            apiAvailableQuantity,
            nativeMaxQuantity
        );

        const currentQuantity = amountInput
            ? Math.max(0, parseInt(amountInput.value, 10) || 0)
            : 0;

        // Pozn.: přepisujeme jen "pracovní" hodnotu (efektivní max),
        // originální skladový limit zůstává bezpečně uložen
        // v row.dataset.nativeMaxQuantity.
        row.dataset.maxAvailableQuantity =
            String(availableQuantity);

        row.dataset.availabilityLoaded = 'true';

        if (amountInput) {
            amountInput.max = String(availableQuantity);
            amountInput.dataset.maxAvailable =
                String(availableQuantity);

            amountInput.classList.toggle(
                'amount-over-limit',
                currentQuantity > availableQuantity
            );
        }

        if (increaseButton) {
            const disableIncrease =
                availableQuantity === 0 ||
                currentQuantity >= availableQuantity;

            increaseButton.disabled = disableIncrease;

            increaseButton.setAttribute(
                'aria-disabled',
                disableIncrease ? 'true' : 'false'
            );
        }

        if (increaseTooltip) {
            increaseTooltip.setAttribute(
                'data-original-title',
                product.available
                    ? `Není možné zakoupit více než ${availableQuantity} ks.`
                    : 'Produkt není pro vybrané datum dostupný.'
            );
        }

        availabilityLabels.forEach(function (label) {
            if (!product.exists) {
                label.textContent = 'Produkt nebyl nalezen';
            } else if (!product.active) {
                label.textContent = 'Produkt není aktivní';
            } else if (!product.hasBakeDay) {
                label.textContent = 'V tento den nepečeme';
            } else if (!product.available || availableQuantity === 0) {
                label.textContent = 'Vyprodáno';
            } else {
                label.textContent =
                    `Maximálně ${availableQuantity} ks`;
            }
        });
    }

    /*
     * Vlastní jednoduchá bublina pro hlášku o limitu.
     * Používá se jen jako FALLBACK, kdyby na webu z nějakého
     * důvodu nebyl k dispozici Bootstrap tooltip (viz níže).
     */
    let limitTooltipBubble = null;
    let limitTooltipHideTimer = null;

    function getLimitTooltipBubble() {
        if (limitTooltipBubble) {
            return limitTooltipBubble;
        }

        const bubble = document.createElement('div');

        bubble.className = 'cartLimitTooltipBubble';
        bubble.setAttribute('role', 'status');
        bubble.setAttribute('aria-live', 'polite');

        Object.assign(bubble.style, {
            position: 'fixed',
            zIndex: '9999',
            maxWidth: '260px',
            padding: '8px 12px',
            borderRadius: '6px',
            background: 'rgba(33, 33, 33, 0.95)',
            color: '#fff',
            fontSize: '13px',
            lineHeight: '1.35',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
            pointerEvents: 'none',
            opacity: '0',
            transform: 'translateY(4px)',
            transition: 'opacity 0.15s ease, transform 0.15s ease'
        });

        document.body.appendChild(bubble);

        limitTooltipBubble = bubble;

        return bubble;
    }

    function showFallbackTooltip(anchorEl, message) {
        const bubble = getLimitTooltipBubble();

        bubble.textContent = message;

        const rect = anchorEl.getBoundingClientRect();

        bubble.style.display = 'block';

        const bubbleWidth = bubble.offsetWidth;

        let left = rect.left + rect.width / 2 - bubbleWidth / 2;

        left = Math.max(
            8,
            Math.min(left, window.innerWidth - bubbleWidth - 8)
        );

        const top = rect.top - bubble.offsetHeight - 8;

        bubble.style.left = left + 'px';

        bubble.style.top = (
            top < 8 ? rect.bottom + 8 : top
        ) + 'px';

        void bubble.offsetHeight;

        bubble.style.opacity = '1';
        bubble.style.transform = 'translateY(0)';
    }

    function hideFallbackTooltip() {
        if (!limitTooltipBubble) {
            return;
        }

        limitTooltipBubble.style.opacity = '0';
        limitTooltipBubble.style.transform = 'translateY(4px)';
    }

    // Schová fallback bublinu i při scrollu/resize, ať
    // nezůstane "přilepená" na špatném místě.
    window.addEventListener(
        'scroll',
        function () {
            hideFallbackTooltip();
        },
        true
    );

    window.addEventListener('resize', function () {
        hideFallbackTooltip();
    });

    /**
     * Zajistí, že je prvek inicializovaný jako Bootstrap
     * tooltip STEJNĚ, jako to dělá vlastní window.initTooltips()
     * webu (html:true, placement:'auto', container:'body').
     *
     * Náš .js-increase-tooltip prvek nemá třídu "show-tooltip",
     * takže ho initTooltips() na webu nikdy sám neinicializuje -
     * proto to musíme udělat tady, se stejnou konfigurací, aby
     * tooltip vypadal a choval se stejně jako zbytek webu.
     *
     * Vrací jQuery objekt, pokud je Bootstrap tooltip k dispozici,
     * jinak null (pak se použije vlastní fallback bublina).
     */
    function ensureBootstrapTooltip(tooltipEl) {
        if (!window.jQuery) {
            return null;
        }

        const $tooltip = window.jQuery(tooltipEl);

        if (typeof $tooltip.tooltip !== 'function') {
            return null;
        }

        if (!$tooltip.hasClass('show-tooltip')) {
            $tooltip.addClass('show-tooltip');
        }

        const isInitialized = Boolean(
            $tooltip.data('bs.tooltip') ||
            $tooltip.data('tooltip')
        );

        if (!isInitialized) {
            $tooltip.tooltip({
                html: true,
                placement: 'auto',
                container: 'body'
            });
        }

        return $tooltip;
    }

    /**
     * Zobrazí hlášku o limitu - pokud možno přes skutečný
     * Bootstrap tooltip webu (stejný vzhled jako zbytek webu),
     * jinak přes vlastní fallback bublinu.
     *
     * Text bere vždy z aktuálního data-original-title (to
     * nastavuje setRowAvailability), takže se při .tooltip('show')
     * ukáže vždy aktuální hláška.
     *
     * Po chvíli se tooltip sám schová, aby nezůstával
     * viset na obrazovce natrvalo.
     */
    function showLimitTooltip(tooltipEl) {
        if (!tooltipEl) {
            return;
        }

        const message =
            tooltipEl.getAttribute('data-original-title') ||
            tooltipEl.getAttribute('title');

        if (!message) {
            return;
        }

        const $tooltip = ensureBootstrapTooltip(tooltipEl);

        clearTimeout(tooltipEl._limitTooltipHideTimer);

        if ($tooltip) {
            $tooltip.tooltip('show');

            tooltipEl._limitTooltipHideTimer = setTimeout(
                function () {
                    $tooltip.tooltip('hide');
                },
                2500
            );

            return;
        }

        // Fallback, kdyby na webu Bootstrap tooltip nebyl
        // vůbec k dispozici.
        showFallbackTooltip(tooltipEl, message);

        tooltipEl._limitTooltipHideTimer = setTimeout(
            hideFallbackTooltip,
            2500
        );
    }

    /**
     * Okamžitě schová hlášku o limitu (ať už jde o
     * Bootstrap tooltip, nebo vlastní fallback bublinu).
     */
    function hideLimitTooltip(tooltipEl) {
        if (!tooltipEl) {
            return;
        }

        clearTimeout(tooltipEl._limitTooltipHideTimer);

        if (window.jQuery) {
            const $tooltip = window.jQuery(tooltipEl);

            const isInitialized = Boolean(
                typeof $tooltip.tooltip === 'function' &&
                ($tooltip.data('bs.tooltip') || $tooltip.data('tooltip'))
            );

            if (isInitialized) {
                $tooltip.tooltip('hide');

                return;
            }
        }

        hideFallbackTooltip();
    }

    /**
     * Zobrazí/skryje v košíku hlášku, že v něm je
     * produkt, který pro vybraný termín vyzvednutí
     * není dostupný (product.available === false).
     */
    function updateCartAvailabilityNotice(unavailableProducts) {

        const summaryWrapper = document.querySelector(
            '.cart-content.summary-wrapper'
        );

        if (!summaryWrapper) {
            return;
        }

        const existingMessage = summaryWrapper.querySelector(
            '.cartUnavailableProductsMessage'
        );

        if (!unavailableProducts || !unavailableProducts.length) {
            if (existingMessage) {
                existingMessage.remove();
            }

            summaryWrapper.classList.remove('notAllowed');

            return;
        }

        const names = unavailableProducts
            .map(function (product) {
                return product.name || product.code;
            })
            .join(', ');

        const messageText =
            'V košíku máte produkt, který pro vybraný termín ' +
            'vyzvednutí nelze dodat (' + names + '). ' +
            'Odeberte ho prosím z košíku, nebo zvolte jiný <a href="/">termín vyzvednutí</a>.';

        if (existingMessage) {
            existingMessage.innerHTML = messageText;
            summaryWrapper.classList.add('notAllowed');

            return;
        }

        const message = document.createElement('div');

        message.className = 'cartUnavailableProductsMessage';
        message.innerHTML = messageText;

        summaryWrapper.prepend(message);
        summaryWrapper.classList.add('notAllowed');
    }

    /**
     * Načte dostupnost všech položek v košíku.
     */
    async function loadCartAvailability() {
        const availabilityDate = getAvailabilityDate();

        if (!availabilityDate) {
            console.warn(
                'Dostupnost košíku nelze načíst: není vybraný termín.'
            );

            return;
        }

        const rows = Array.from(
            document.querySelectorAll(
                '.removeable[data-micro-sku]'
            )
        );

        if (rows.length === 0) {
            updateCartAvailabilityNotice([]);

            return;
        }

        const rowsBySku = new Map();

        rows.forEach(function (row) {
            // Musí proběhnout dřív, než API odpověď případně
            // přepíše data-max-available-quantity na řádku.
            captureNativeMaxQuantity(row);

            const sku = String(
                row.getAttribute('data-micro-sku') || ''
            ).trim();

            if (!sku) {
                return;
            }

            if (!rowsBySku.has(sku)) {
                rowsBySku.set(sku, []);
            }

            rowsBySku.get(sku).push(row);
        });

        const codes = Array.from(rowsBySku.keys());

        if (codes.length === 0) {
            return;
        }

        /*
         * Zruší předchozí požadavek, pokud se košík
         * mezitím znovu překreslil.
         */
        if (availabilityController) {
            availabilityController.abort();
        }

        availabilityController = new AbortController();

        try {
            const response = await fetch(
                AVAILABILITY_ENDPOINT,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        date: availabilityDate,
                        codes: codes
                    }),
                    signal: availabilityController.signal
                }
            );

            const data = await response.json();

            if (!response.ok || data.success !== true) {
                throw new Error(
                    data.message ||
                    `HTTP chyba ${response.status}`
                );
            }

            if (!Array.isArray(data.products)) {
                throw new Error(
                    'Odpověď neobsahuje pole products.'
                );
            }

            data.products.forEach(function (product) {
                const sku = String(product.code || '').trim();
                const productRows = rowsBySku.get(sku) || [];

                productRows.forEach(function (row) {
                    setRowAvailability(row, product);
                });
            });

            const unavailableProducts = data.products.filter(
                function (product) {
                    return product.available === false;
                }
            );

            updateCartAvailabilityNotice(unavailableProducts);

            document.dispatchEvent(
                new CustomEvent(
                    'CartAvailabilityLoaded',
                    {
                        detail: data
                    }
                )
            );
        } catch (error) {
            if (error.name === 'AbortError') {
                return;
            }

            console.error(
                'Chyba při načítání dostupnosti:',
                error
            );
        } finally {
            availabilityController = null;
        }
    }

    /**
     * Odložené spuštění zabrání opakovaným requestům,
     * když Shoptet vyvolá více událostí těsně za sebou.
     */
    function scheduleCartAvailability() {
        clearTimeout(availabilityTimer);

        availabilityTimer = setTimeout(function () {
            loadCartAvailability();
        }, 100);
    }

    /**
     * Shoptet překreslil obsah košíku.
     */
    document.addEventListener(
        'ShoptetDOMCartContentLoaded',
        function () {
            scheduleCartAvailability();
        }
    );

    /**
     * Shoptet dokončil načtení DOM.
     */
    document.addEventListener(
        'ShoptetDOMContentLoaded',
        function () {
            scheduleCartAvailability();
        }
    );

    if (window.jQuery) {
    window.jQuery(function () {
        scheduleCartAvailability();
    });

    window.jQuery(document).on(
        'klasekDateSelected klasekPickupConfirmed',
        function () {
            scheduleCartAvailability();
        }
    );
    }

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            scheduleCartAvailability,
            { once: true }
        );
    } else {
        scheduleCartAvailability();
    }

    /**
     * jQuery document ready, pokud je jQuery dostupné.
     */
    if (window.jQuery) {
        window.jQuery(function () {
            scheduleCartAvailability();
        });
    }

    /**
     * Kontrola ručně zadaného množství.
     */
    document.addEventListener('input', function (event) {
        const amountInput = event.target.closest(
            '.removeable[data-micro-sku] input.amount'
        );

        if (!amountInput) {
            return;
        }

        const row = amountInput.closest(
            '.removeable[data-micro-sku]'
        );

        const increaseButton = row.querySelector(
            'button.increase'
        );

        const increaseTooltip = row.querySelector(
            '.js-increase-tooltip'
        );

        const maxQuantity = Math.max(
            0,
            parseInt(
                amountInput.dataset.maxAvailable,
                10
            ) || 0
        );

        const currentQuantity = Math.max(
            0,
            parseInt(amountInput.value, 10) || 0
        );

        const isOverLimit =
            currentQuantity > maxQuantity;

        amountInput.classList.toggle(
            'amount-over-limit',
            isOverLimit
        );

        if (increaseButton) {
            increaseButton.disabled =
                maxQuantity === 0 ||
                currentQuantity >= maxQuantity;
        }

        /*
         * Uživatel zadáním ručně narazil na limit
         * (nebo ho překročil) - ukážeme mu proč.
         */
        if (currentQuantity >= maxQuantity && maxQuantity > 0) {
            showLimitTooltip(increaseTooltip);
        } else {
            hideLimitTooltip(increaseTooltip);
        }
    });

    /**
     * Schová tooltip s limitem, jakmile uživatel
     * opustí pole s množstvím.
     */
    document.addEventListener(
        'blur',
        function (event) {
            const amountInput = event.target.closest
                ? event.target.closest(
                    '.removeable[data-micro-sku] input.amount'
                )
                : null;

            if (!amountInput) {
                return;
            }

            const row = amountInput.closest(
                '.removeable[data-micro-sku]'
            );

            const increaseTooltip = row.querySelector(
                '.js-increase-tooltip'
            );

            hideLimitTooltip(increaseTooltip);
        },
        true
    );

    /**
     * Zablokování tlačítka plus po dosažení maxima.
     */
    document.addEventListener(
        'click',
        function (event) {
            const increaseButton = event.target.closest(
                '.removeable[data-micro-sku] button.increase'
            );

            if (!increaseButton) {
                return;
            }

            const row = increaseButton.closest(
                '.removeable[data-micro-sku]'
            );

            const amountInput = row.querySelector(
                'input.amount'
            );

            if (!amountInput) {
                return;
            }

            const increaseTooltip = row.querySelector(
                '.js-increase-tooltip'
            );

            const maxQuantity = Math.max(
                0,
                parseInt(
                    amountInput.dataset.maxAvailable,
                    10
                ) || 0
            );

            const currentQuantity = Math.max(
                0,
                parseInt(amountInput.value, 10) || 0
            );

            if (currentQuantity >= maxQuantity) {
                event.preventDefault();
                event.stopImmediatePropagation();

                showLimitTooltip(increaseTooltip);
            }
        },
        true
    );

    /*
     * Funkce dostupná také globálně, například po změně data:
     *
     * window.loadCartAvailability();
     */
    window.loadCartAvailability =
        scheduleCartAvailability;
})();